import logo from './Media/Hakamari.png'
import Navigation from './Navigation'

const Header = () => {
    return (
        <header className="App-header">
            <a href="/" className="header-brand">
                <img src={logo} width={44} height={44} className="App-logo" alt="logo" />
                <span className="brand-name">HAKAMARI</span>
            </a>
            <Navigation></Navigation>
      </header>
        )
    }

export default Header